/**
 * Resolve desktop/mobile page backgrounds from themeset `pages_bg`.
 * Falls back to per-stage `background_desk` / `background_mob` when set.
 */
export function resolvePageBackground(pagesBg, pageKey, stageData) {
  const bg = pagesBg && typeof pagesBg === 'object' ? pagesBg : {};
  const stage = stageData && typeof stageData === 'object' ? stageData : {};
  const pick = (v) => String(v ?? '').trim();

  const desk =
    pick(bg[`${pageKey}_desk`]) ||
    pick(bg[pageKey]) ||
    pick(stage.background_desk) ||
    '';

  const mob =
    pick(bg[`${pageKey}_mob`]) ||
    pick(bg[pageKey]) ||
    pick(stage.background_mob) ||
    desk;

  return { desk, mob };
}

/**
 * Intro-only, desktop-only background video (never shown on mobile).
 * When set, it takes priority over the intro desktop image.
 */
export function resolveIntroDeskVideo(pagesBg) {
  const bg = pagesBg && typeof pagesBg === 'object' ? pagesBg : {};
  return String(bg.intro_desk_video ?? '').trim();
}

export const FUTURE_PAGE_BG_KEYS = {
  intro: 'intro',
  introMap: 'intro_map',
  stage1: 'stage_1',
  stage2: 'stage_2',
  stage3: 'stage_3',
  stage4: 'stage_4',
  stage5: 'stage_5',
  stage6: 'stage_6',
  stage7: 'stage_7',
  thankyou: 'thankyou',
};
